import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule  } from '@angular/core';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
// import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CookieModule } from 'ngx-cookie';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';

// import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
// import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';

import { WalletWeb3Service } from '@services/web3modal.service';
import { UserApiService } from '@http/user-api.service';

import pack from '../../package.json';
import { environment } from '@env/environment';
import { HttpRequestInterceptor } from '@http/interceptors/http.service';
import { CustomTranslateHttpLoader } from '@utils/CustomTranslateHttpLoader';
import { STORAGE_KEY } from '@http/interfaces/inject-tokens';
import { IntlMessageFormatCompiler } from '@services/intl-message-format.compiler';

import { AuthService } from '@services/auth.service';
import { LanguageStateService } from '@services/language-state.service';
import { ServerNotRespondingService } from '@services/server-not-responding.service';

import { AppComponent } from './app.component';
import { ServerNotRespondingComponent } from './components/server-not-responding/server-not-responding.component';
import { RestrictedLayoutComponent } from './components/layout/layout.component';
import { HeaderBannerComponent, HeaderComponent, HeaderNavbarComponent } from './components/header';
import { NotFound404Component } from './components/not-found404/not-found404.component';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './components/footer/footer.component';
import { AuthComponent } from './components/auth/auth.component';
import { ModalsModule } from './modals/modals.module';
import { TemporaryDowntimeComponent } from './components/temporary-downtime/temporary-downtime.component';

export const createTranslateLoader = (http: HttpClient, languageStateService: LanguageStateService) =>
  new CustomTranslateHttpLoader(
    http,
    'dapp',
    languageStateService,
    './assets/i18n/',
    '.json',
    environment.env,
  );

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params.key;
  }
}

console.log(`%c Version: ${pack.version}`, 'color: blue');


@NgModule({
  declarations: [
    AppComponent,
    ServerNotRespondingComponent,
    NotFound404Component,
    RestrictedLayoutComponent,
    HeaderComponent,
    HeaderNavbarComponent,
    HeaderBannerComponent,
    FooterComponent,
    AuthComponent,
    TemporaryDowntimeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    CookieModule.forRoot({ sameSite: 'strict' }),
    ToastrModule.forRoot({
      enableHtml: true,
      positionClass: 'toast-top-right',
      toastClass: 'cd-toast',
      closeButton: true,
      timeOut: 4000,
    }),
    TranslateModule.forRoot({
      defaultLanguage: localStorage['language'] || 'en',
      compiler: {
        provide: TranslateCompiler,
        useClass: IntlMessageFormatCompiler,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
      },
      useDefaultLang: false,
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, LanguageStateService],
      },
    }),
    SharedModule,
    ModalsModule
  ],
  providers: [
    WalletWeb3Service,
    AuthService,
    UserApiService,
    LanguageStateService,
    ServerNotRespondingService,
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => auth.initialize(),
      deps: [AuthService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: STORAGE_KEY,
      useValue: 'dapp_config_storage',
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }